import styled, { css } from 'styled-components';
import { Modal, Scrollbar } from 'ui-components/src/components/atoms';
import { TabbedLayout } from 'ui-components/src/components/molecules/TabbedLayout';

export const StyledModal = styled(Modal)`
  width: 800px;
  height: 500px;

  .content {
    height: calc(100% - 50px);
  }
`;

export const StyledTabbedLayout = styled(TabbedLayout)`
  height: 100%;

  .tabHeader {
    margin-bottom: 0.75rem;
  }

  .tabPages {
    height: calc(100% - 51px);
  }

  .tabPage {
    height: 100%;
  }
`;

export const Header = styled.header`
  height: 50px;
  padding-left: 24px;
  margin-bottom: 8px;

  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyWarm['20']};
`;

export const Pane = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;
  padding-right: 1rem;
  overflow-y: scroll;
  ${css`
    ${Scrollbar.secondary.join('')}
  `};
`;

export const Divider = styled.div`
  position: relative;
  top: 1px;
  height: 1px;
  margin-right: 2rem;
  background-color: ${({ theme }) => theme.colors.greyWarm['20']};
`;

export const Content = styled.div`
  padding-left: 2px;
`;
